import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import './PageHeader.css';

function PageHeader({
  icon: Icon,
  title,
  subtitle,
  showBackButton = true,
  onBack,
  showUserInfo = true,
  greeting = "Welcome back",
  children
}) {
  const navigate = useNavigate();
  const { currentTransaction } = useApp();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="page-header">
      {/* Background Pattern */}
      <div className="header-bg-pattern"></div>

      {/* Header Content */}
      <div className="header-content">
        {/* Top Bar - Back Button only */}
        {showBackButton && (
          <div className="header-top-bar">
            <button className="back-button" onClick={handleBack}>
              <ArrowLeft size={18} />
              <span>Back</span>
            </button>
          </div>
        )}

        {/* User Info Section */}
        {showUserInfo && currentTransaction?.userName ? (
          <div className="user-section">
            <h1 className="user-name">{currentTransaction.userName}</h1>
            <p className="user-cnic">{currentTransaction.userCnic}</p>
            <div className="user-bottom-row">
              <span className="user-greeting">{greeting}</span>
              <span className="secured-badge">
                <Shield size={11} />
                <span>Secured</span>
              </span>
            </div>
          </div>
        ) : (Icon || title) && (
          <div className="generic-section">
            {Icon && (
              <div className="header-icon">
                <Icon size={24} />
              </div>
            )}
            {title && (
              <div className="header-text">
                <h1 className="header-title">{title}</h1>
                {subtitle && <p className="header-subtitle">{subtitle}</p>}
              </div>
            )}
          </div>
        )}

        {/* Children/Extra Content */}
        {children && <div className="header-extra">{children}</div>}
      </div>
    </div>
  );
}

export default PageHeader;
